let baseUrl = "";
let baseUrlOrigin = "";
export const WebSocketURL = "wss://hau-tu-opr.moleawiz.com/ws";

const environment = import.meta.env.VITE_ENVIRONMENT;

if (environment === "production") {
  baseUrl =
    "https://hau-tu-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://hau-tu-opr.moleawiz.com"
} else if (environment === "staging") {
  baseUrl =
    "https://hau-tu-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://hau-tu-opr.moleawiz.com"
} else {
  baseUrl =
    "https://hau-tu-opr.moleawiz.com/api/public/index.php";
    baseUrlOrigin = "https://hau-tu-opr.moleawiz.com"
}

export { baseUrlOrigin };
export default baseUrl;
